import React from "react";


const DisabledTextBox = ({ className = "" }) => {
  return (
    <input
      type="text"
      disabled
      className={`w-1/2 h-32 rounded-md shadow-sm border border-gray-300 bg-white-100 text-center text-black ${className}`}
    />
  );
};

export default DisabledTextBox;
